import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  // useRouteMatch,
} from "react-router-dom";
import { GlobalHeader } from "./pages/GlobalHeader";
import { Team } from "./pages/Team";
import { Background } from "./pages/Mint";
import { DappContext } from "../contexts/MintContext";
import { Splash } from "./pages/Splash";
import { urlNOFS, urlTUNE } from "../common/configs";
import { Wallet } from "./pages/Wallet";

export function App(): React.ReactElement {
  const path = "/bubos";
  return(
    <>
      <Router>
        <Route exact path={"/launchpad/tune"}
          component={ (): null => { 
            window.location.replace(urlTUNE); 
            return null;
          }}
        />
        <Route exact path={"/nofs"}
          component={ (): null => { 
            window.location.replace(urlNOFS); 
            return null;
          }}
        />
        <Route exact path={"/home"}>
          <Splash />
        </Route>
        <Route exact path={"/"}>
          <Redirect to={"/home"} />
        </Route>
      </Router>
      <Router basename={path}>
        <DappContext>
        <Route exact path={"/mint"}>
          <GlobalHeader />
          <Background />
        </Route>
        <Route exact path={"/wallet"}>
          <GlobalHeader />
          <Wallet />
        </Route>
        <Route exact path={"/team"}>
          <GlobalHeader />
          <Team />
        </Route>
        <Route exact path={"/bubos"}>
          <Redirect to={"/mint"}/>
        </Route>
        </DappContext>
      </Router>
    </>
  )
}